import React from 'react';
import { twMerge } from 'tailwind-merge';
import { Link } from 'ui-components/common/Link';

interface KeywordProps {
  className?: string;
  keyword: string;
  onClick?: React.MouseEventHandler<HTMLAnchorElement>;
  variant?: 'search' | 'content';
}

const KEYWORD_STYLES = {
  base: 'cursor-pointer justify-center px-[4px] py-[1px]',
  search: {
    container: 'inline-flex border-[1px] border-solid border-gray-300/70 rounded-md',
    text: 'text-sm font-medium text-gray-500',
  },
  content: {
    container: 'inline-block rounded bg-gray-200',
    text: 'text-xxxs leading-[18px] font-medium text-gray-600',
  },
} as const;

export const SectionContentKeyword = ({ className, keyword, onClick, variant = 'content' }: KeywordProps) => {
  const href = `/search?q=${encodeURIComponent(`#${keyword}`)}`;
  const displayText = variant === 'search' ? `#${keyword}` : keyword;

  return (
    <Link
      href={href}
      className={twMerge(
        className,
        KEYWORD_STYLES.base,
        KEYWORD_STYLES[variant].container,
        KEYWORD_STYLES[variant].text,
      )}
      onClick={onClick}>
      {displayText}
    </Link>
  );
};
